(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("openlayers"), require("olExt"), require("jQuery"), require("jsts"));
	else if(typeof define === 'function' && define.amd)
		define("Descartes", ["openlayers", "olExt", "jQuery", "jsts"], factory);
	else if(typeof exports === 'object')
		exports["Descartes"] = factory(require("openlayers"), require("olExt"), require("jQuery"), require("jsts"));
	else
		root["Descartes"] = factory(root["ol"], root["olExt"], root["$"], root["jsts"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_388__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_125__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition